import {DEFAULT_TIME_ZONE} from "@/global/DateUtils";

/**
 * Vigencia del servicio de una empresa (service_end_date / service_end_reason).
 *
 * Regla de negocio: la empresa está vigente hasta las 23:59:59 hora Colombia de su fecha de finalización;
 * vencida si fecha < hoy. Si al guardar la fecha es anterior a hoy, el motivo es obligatorio.
 * El backend (v1/create) es la validación definitiva; aquí solo se anticipa en el formulario.
 */
export const SERVICE_END_REASONS = [
    {id: "G", name: "Garantía"},
    {id: "S", name: "Suscripción"},
];

const pad = value => String(value).padStart(2, "0");

/**
 * Date local -> "yyyy-MM-dd" (formato de LocalDateDeserializer). No usar toISOString: convierte a UTC y
 * después de las 19:00 hora Colombia corre la fecha un día atrás.
 */
export const toIsoDate = date => {
    if (!date) {
        return null;
    }
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

/** "yyyy-MM-dd" -> Date local (new Date("yyyy-MM-dd") lo interpretaría en UTC). */
export const fromIsoDate = value => {
    if (!value) {
        return null;
    }
    const [year, month, day] = value.split("-").map(Number);
    return new Date(year, month - 1, day);
};

/** Hoy en hora Colombia como "yyyy-MM-dd" (en-CA formatea en ese orden). */
export const businessToday = () =>
    new Intl.DateTimeFormat("en-CA", {timeZone: DEFAULT_TIME_ZONE}).format(new Date());

export const isBeforeToday = date => Boolean(date) && toIsoDate(date) < businessToday();

/** "yyyy-MM-dd" -> "dd/MM/yyyy" para mostrar. */
export const toDisplayDate = value => {
    if (!value) {
        return "";
    }
    const [year, month, day] = value.split("-");
    return `${day}/${month}/${year}`;
};
